import { useTranslation } from 'react-i18next';
import { EntraGroup } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { Button } from '@sib/ui';
import { Switch } from '@sib/ui/icons';
import { useDialog } from '../hooks';
import { OrganizationSwitchDialog } from './OrganizationSwitchDialog';

interface OrganizationSwitchProps {
  className?: string;
}

export const OrganizationSwitch = (props: OrganizationSwitchProps) => {
  const { isOpen, handleOpen, handleClose } = useDialog();
  const { userRoles } = useUserSetupStore();
  const { t } = useTranslation();

  const isUserAllowedToSwitchOrganization =
    userRoles.includes(EntraGroup.Cms) ||
    userRoles.includes(EntraGroup.Employee);

  return isUserAllowedToSwitchOrganization ? (
    <>
      <Button onClick={handleOpen} variant="outline" {...props}>
        <Switch className="text-primary h-5 w-5" />
        <span className="hidden sm:block">
          {t('components.organizationSwitch.title')}
        </span>
      </Button>
      <OrganizationSwitchDialog open={isOpen} onClose={handleClose} />
    </>
  ) : null;
};
